var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-loading mdi-spin")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }